module.exports = __webpack_public_path__ + "img/Shield Healthy.926080fb.png";